import { useIntl } from "react-intl";
import SearchAutocomplete from "../../../form/searchAutocomplete";
import {
  fetchOccurrenceSummary,
  IOccurrenceSummary,
} from "../../../../api/fetchOccurence";
import { OccurrenceStepEnum } from "../../../../enums/occurrenceStep";
import { BudgetRecipient } from "../../enums/budgetRecipient";

interface IBudgetOccurrenceSelectProps {
  profile?: BudgetRecipient;
  disabled?: boolean;
  onSelect: (occurrence: IOccurrenceSummary) => void;
  onClear: () => void;
}

export const BudgetOccurrenceSelect = (props: IBudgetOccurrenceSelectProps) => {
  const intl = useIntl();
  const { profile, disabled, onSelect, onClear } = props;

  return (
    <div className="mb-2 mt-5 px-6">
      <div className="py-6 bg-white border-t border-gray-200">
        <label htmlFor="occurrenceSearch" className="font-bold mb-1 block">
          {intl.formatMessage({ id: "intl-msg:budgets.searchOccurrence" })}
        </label>
        <div className="w-full">
          <SearchAutocomplete
            id="occurrenceSearch"
            placeholder={intl.formatMessage({ id: "intl-msg:budgets.searchOccurrencePlaceholder" })}
            fetchDefaultOptionsOnEmptySearch
            disabled={disabled || !profile}
            fetchOptions={(searchTerm: string) =>
              fetchOccurrenceSummary(
                profile,
                searchTerm,
                OccurrenceStepEnum.THIRD_DIAGNOSIS,
              )
            }
            optionLabel={{
              protocolNumber: intl.formatMessage({ id: "intl-msg:budgets.occurrence" }),
              vehicleChassis: intl.formatMessage({ id: "intl-msg:budgets.kanban.chassis" }),
            }}
            onSelectedOption={(occurrence: IOccurrenceSummary) => {
              onSelect(occurrence);
            }}
            valueRenderer={(option: IOccurrenceSummary) =>
              `${option.protocolNumber} - ${option.vehicleChassis}`
            }
            optionRenderer={(option: IOccurrenceSummary) => (
              <div className="truncate">
                <div className="font-medium">{option.protocolNumber}</div>
                <div className="text-sm text-gray-500">
                  {intl.formatMessage({ id: "intl-msg:budgets.kanban.chassis" })}: {option.vehicleChassis}
                </div>
              </div>
            )}
            onClear={onClear}
          />
        </div>
      </div>
    </div>
  );
};
